import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6a1cdec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Marketplace Reservations", -1))
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "row form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "active" }, "Active", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "canceled" }, "Canceled", -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Name")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Phone")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Email")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Unit Name")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Unit Type")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Move-in Date")
  ]),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 3,
  class: "text-center",
  style: {"margin-top":"15px"}
}
const _hoisted_18 = { key: 4 }

import { onMounted, ref } from "vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitTypeInterface, MarketplaceInterface } from "@/types/customers";
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
import moment from "moment";

import BaseSpinner from "@/components/BaseSpinner.vue";
import { UnitInterface } from "@/types/unit";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
  facilityName: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;

const status = ref("loading");
const searchCustomer = ref("");
const marketplaceReservations = ref(Array<MarketplaceInterface>());
const selectedType = ref(null);
const filteredReservations = ref(Array<MarketplaceInterface>());
const errors = ref("");
const units = ref(Array<UnitInterface>());

const selectedFilter = ref("name");
const unitTypes = ref();
const formSubmitting = ref(false);
const filterOptions = ref([
  { text: "Name", value: "name" },
  { text: "Phone or Cell Phone", value: "phone" },
]);

onMounted(async () => {
  await router.isReady();
  await getUnits();
  await getUnitTypes();
  await getMarketplaceReservations();
});

async function getUnits() {
  errors.value = "";
  const response = await api({
    url: `units/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    units.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function search() {
  status.value = "loading";
  await getMarketplaceReservations();
  if (searchCustomer.value.length || selectedType.value) {
    let searchValue = searchCustomer.value.trim();
    if (selectedFilter.value == "name") {
      filteredReservations.value = marketplaceReservations.value.filter(
        (item: MarketplaceInterface) =>
          (item.first_name + " " + item.last_name)
            .toLowerCase()
            .includes(searchValue.toLowerCase())
      );
    } else {
      filteredReservations.value = marketplaceReservations.value.filter(
        (item: MarketplaceInterface) =>
          item.phone && item.phone.includes(searchValue)
      );
    }
  } else {
    filteredReservations.value = marketplaceReservations.value;
  }
  status.value = "completed";
}

async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getMarketplaceReservations() {
  let url = `marketplace_reservations/?facilityId=${props.facilityId}`;
  if (selectedType.value) {
    url += `&filter=${selectedType.value}`;
  }
  const response = await api({
    url: url,
  });
  if (response.status == 200) {
    marketplaceReservations.value = response.body;
    for (let reservation of marketplaceReservations.value) {
      reservation.unit = units.value.filter(
        (item: UnitInterface) => item.id == reservation.unit_id.toString()
      )[0];
      if (reservation.unit && reservation.unit.unit_type_id) {
        reservation.size = unitTypes.value.filter(
          (item: UnitTypeInterface) =>
            item.id == reservation.unit.unit_type_id.toString()
        )[0];
      }
    }
    filteredReservations.value = marketplaceReservations.value;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "completed";
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(api_settings).reservation_search)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchCustomer).value = $event)),
              type: "text",
              style: {"max-width":"840px"},
              placeholder: "Search...",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (search()), ["enter"]))
            }, null, 544), [
              [_vModelText, searchCustomer.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedFilter).value = $event)),
              class: "form-select",
              style: {"max-width":"210px"},
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (search()), ["enter"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (filter) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: filter + 'filter',
                  value: filter.value
                }, _toDisplayString(filter.text), 9, _hoisted_4))
              }), 128))
            ], 544), [
              [_vModelSelect, selectedFilter.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedType).value = $event)),
              class: "form-select",
              style: {"max-width":"150px"},
              onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (search()), ["enter"]))
            }, _hoisted_8, 544), [
              [_vModelSelect, selectedType.value]
            ]),
            _createElementVNode("button", {
              class: "btn",
              onClick: search
            }, "Search")
          ])
        ]))
      : _createCommentVNode("", true),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 1,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (filteredReservations.value && filteredReservations.value.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredReservations.value, (reservation) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: reservation.id + 'customer'
            }, [
              _createElementVNode("td", null, _toDisplayString(reservation.first_name) + " " + _toDisplayString(reservation.last_name), 1),
              _createElementVNode("td", null, _toDisplayString(reservation.phone), 1),
              _createElementVNode("td", null, _toDisplayString(reservation.email), 1),
              _createElementVNode("td", null, _toDisplayString(reservation.unit.name), 1),
              (
          reservation.size && reservation.size.length && reservation.size.width
        )
                ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                    _createTextVNode(_toDisplayString(reservation.size.length) + "x" + _toDisplayString(reservation.size.width) + " ", 1),
                    (reservation.size.height)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("x " + _toDisplayString(reservation.size.height), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : (reservation.size)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(reservation.size), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_13)),
              _createElementVNode("td", null, _toDisplayString(reservation.move_in_on), 1),
              _createElementVNode("td", null, [
                (!reservation.canceled_at && !reservation.completed_at)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 0,
                      disabled: formSubmitting.value,
                      class: "btn btn-blue",
                      to: {
            name: 'customer',
            params: {
              unitId: reservation.unit_id,
              facilityId: __props.facilityId,
              rental: 'false',
              marketplaceId: reservation.id,
              customerId: null,
            },
          }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["disabled", "to"]))
                  : (reservation.canceled_at)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Canceled on: " + _toDisplayString(_unref(moment)(reservation.canceled_at).format("YYYY-MM-DD")), 1))
                    : (reservation.completed_at)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Completed on: " + _toDisplayString(_unref(moment)(reservation.completed_at).format("YYYY-MM-DD")), 1))
                      : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : (status.value == 'completed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " No results found "))
        : _createCommentVNode("", true),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})